import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PaymentMethod from './payment-method-model'
import {
  CreatePaymentMethodAsync,
  DeletePaymentMethodAsync,
  LoadPaymentMethodsAsync,
} from './paymentMethod-thunk'
const initialState: paymentMethodSliceState = {
  paymentMethod: [],
  selected_paymentMethod: '',
  is_loading_paymentMethod: false,
  is_creating_paymentMethod: false,
  is_deleting_paymentMethod: false,
}
export interface paymentMethodSliceState {
  paymentMethod: PaymentMethod[]
  selected_paymentMethod?: string
  is_loading_paymentMethod: boolean
  is_creating_paymentMethod: boolean
  is_deleting_paymentMethod: boolean
}
export const paymentMethodSlice = createSlice({
  name: 'paymentMethod',
  initialState,
  reducers: {
    setSelectedpaymentMethod: (state, action) => {
      state.selected_paymentMethod = action.payload
    },
    clearStatepaymentMethod: (state) => {
      state.paymentMethod = []
      state.is_loading_paymentMethod = false
      state.is_creating_paymentMethod = false
      state.is_deleting_paymentMethod = false
    },
    mergepaymentMethod: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_paymentMethod = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.paymentMethod = merge(state.paymentMethod, payload) as any
        }
      }
    },

    add_paymentMethod: (state, action) => {
      if (action.payload) {
        state.paymentMethod = [...state.paymentMethod, action.payload]
      }
    },
    set_paymentMethod: (state, action) => {
      let { key, value, id } = action.payload
      state.paymentMethod = state.paymentMethod.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPaymentMethodsAsync.pending, (state) => {
      state.is_loading_paymentMethod = true
    })
    builder.addCase(LoadPaymentMethodsAsync.fulfilled, (state, action) => {
      state.is_loading_paymentMethod = false
      if (action.payload) {
        state.paymentMethod = action.payload
      }
    })
    builder.addCase(LoadPaymentMethodsAsync.rejected, (state) => {
      state.is_loading_paymentMethod = false
    })
    builder.addCase(CreatePaymentMethodAsync.pending, (state) => {
      state.is_creating_paymentMethod = true
    })
    builder.addCase(CreatePaymentMethodAsync.fulfilled, (state) => {
      state.is_creating_paymentMethod = false
    })
    builder.addCase(CreatePaymentMethodAsync.rejected, (state) => {
      state.is_creating_paymentMethod = false
    })
    builder.addCase(DeletePaymentMethodAsync.pending, (state) => {
      state.is_deleting_paymentMethod = true
    })
    builder.addCase(DeletePaymentMethodAsync.fulfilled, (state, action) => {
      state.is_deleting_paymentMethod = false
      if (state.paymentMethod) {
        state.paymentMethod = state.paymentMethod.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePaymentMethodAsync.rejected, (state) => {
      state.is_deleting_paymentMethod = false
    })
  },
})

export const {
  clearStatepaymentMethod,
  setSelectedpaymentMethod,
  set_paymentMethod,
  mergepaymentMethod,
  add_paymentMethod,
} = paymentMethodSlice.actions

export const get_paymentMethod =
  (id?: string) =>
  (state: {
    paymentMethod: {
      paymentMethod: PaymentMethod[]
    }
  }): PaymentMethod | null => {
    let temp = state?.paymentMethod?.paymentMethod?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.paymentMethod?.paymentMethod[0] || null
  }
export const get_selected_paymentMethod = (state: {
  paymentMethod: paymentMethodSliceState
}): PaymentMethod | null => {
  let id = state?.paymentMethod?.selected_paymentMethod
  let temp = state?.paymentMethod?.paymentMethod?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_paymentMethod = (state: {
  paymentMethod: {
    paymentMethod: PaymentMethod[]
  }
}): PaymentMethod[] => {
  let temp = state?.paymentMethod?.paymentMethod
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_paymentMethod_busy = (state: {
  paymentMethod: paymentMethodSliceState
}) => {
  return (
    state?.paymentMethod.is_deleting_paymentMethod ||
    state?.paymentMethod.is_loading_paymentMethod ||
    state?.paymentMethod.is_creating_paymentMethod
  )
}
export const is_deleting_paymentMethod_busy = (state: {
  paymentMethod: paymentMethodSliceState
}) => {
  return state?.paymentMethod.is_deleting_paymentMethod
}
export const is_loading_paymentMethod_busy = (state: {
  paymentMethod: paymentMethodSliceState
}) => {
  return state?.paymentMethod.is_loading_paymentMethod
}
export const is_creating_paymentMethod_busy = (state: {
  paymentMethod: paymentMethodSliceState
}) => {
  return state?.paymentMethod.is_creating_paymentMethod
}

export default paymentMethodSlice.reducer
